import { render, staticRenderFns } from "./WxUserInfo.vue?vue&type=template&id=1184f5da&scoped=true"
import script from "./WxUserInfo.vue?vue&type=script&lang=js"
export * from "./WxUserInfo.vue?vue&type=script&lang=js"
import style0 from "./WxUserInfo.vue?vue&type=style&index=0&id=1184f5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184f5da",
  null
  
)

export default component.exports